module.exports = __webpack_public_path__ + "static/media/spatium.83c7f481.png";